import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';
import { z } from 'zod';

import { getOneOnOneRatingApi, updateOneOnOneRatingApi } from '../api';

export const oneOnOneRatingValidator = z.number().nullable();

export const getOneOnOneRating = async ({ masterId, instanceId }: OneOnOneRequestI) => {
  try {
    const res = await getOneOnOneRatingApi({ masterId, instanceId });
    const data = oneOnOneRatingValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one rating ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const updateOneOnOneRating = async ({ masterId, instanceId, rating }: { rating: number } & OneOnOneRequestI) => {
  try {
    const res = await updateOneOnOneRatingApi({
      masterId,
      instanceId,
      rating,
    });
    const data = oneOnOneRatingValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error updating one on one rating ', error);
    // throw new Error(generateErrorMessage(error));
  }
};
